import React from "react";
import { Navigate } from "react-router-dom";

const PrivateRoute = ({ children, allowedRoles }) => {
    const token = localStorage.getItem("token");
    const role = localStorage.getItem("role");

    const user = JSON.parse(localStorage.getItem("user") || "{}");
 
    // 1. Not logged in or Account Inactive/Blocked -> Redirect to login
    if (!token || user?.isActive === false || user?.isBlocked === true) {
        if (token) {
            localStorage.clear();
            window.dispatchEvent(new Event("auth-change"));
        }
        return <Navigate to="/customer-login" replace />;
    }

    // 2. Logged in but role not allowed
    // Note: We treat all main roles as having 'user' (buyer) permissions
    let effectiveRoles = [role];
    if (["seller", "admin", "superadmin"].includes(role)) {
        effectiveRoles.push("user");
    }

    const isAuthorized = allowedRoles
        ? allowedRoles.some(r => effectiveRoles.includes(r))
        : true;

    if (!isAuthorized) {
        if (role === "admin" || role === "superadmin") return <Navigate to="/admin/dashboard" replace />;
        if (role === "seller") return <Navigate to="/seller/dashboard" replace />;
        if (role === "pendingseller") return <Navigate to="/pending-seller" replace />;
        return <Navigate to="/buyer/dashboard" replace />;
    }

    // 3. Authorized -> Render children
    return children;
};

export default PrivateRoute;
